export const DEFAULT_INPUT_PREFIX = 'Default - ';
